import { render, staticRenderFns } from "./CustomerMaintenance.vue?vue&type=template&id=00e63cd0&"
import script from "./CustomerMaintenance.vue?vue&type=script&lang=ts&"
export * from "./CustomerMaintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e63cd0')) {
      api.createRecord('00e63cd0', component.options)
    } else {
      api.reload('00e63cd0', component.options)
    }
    module.hot.accept("./CustomerMaintenance.vue?vue&type=template&id=00e63cd0&", function () {
      api.rerender('00e63cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/reports/CustomerMaintenance.vue"
export default component.exports